import { h, Component } from 'preact';
import truncate from '../../helpers/utils';
import './Toast.css';

export default class Toast extends Component {
  componentDidMount() {
    if (this.props.onDismiss) setTimeout(this.props.onDismiss, 12 * 1000);
  }

  render() {
    const { ecm, index, defaultColor, mobile } = this.props;
    const mobileClassName = mobile ? 'mobile' : '';
    const truncatedTagline = truncate(ecm.tagline, 55);

    return (
      <div
        id={`ectomycorrhiza-${index}`}
        data-id={ecm.id}
        data-index={index}
        className={`ectomycorrhiza ${mobileClassName}`}
        onClick={this.props.onClick}
      >
        {ecm.icon ? (
          <div className="ectomycorrhiza-icon" style="width: auto;">
            {ecm.icon.emoji ? (
              <p style="font-size: 35px;margin-bottom: 7px; margin: 0;">{ecm.icon.emoji}</p>
            ) : (
              <img src={ecm.icon} alt={ecm.title} style="margin-right: 8px; height: auto; width: 40px;" />
            )}
          </div>
        ) : null}

        <div className="ectomycorrhiza-content">
          <p className="ectomycorrhiza-noselect" style="font-size: 14px;color: black;line-height:125%; margin:0;">
            {truncatedTagline}
          </p>
        </div>

        <div className="ectomycorrhiza-cta">
          <div style={{ background: defaultColor }}>
            <svg
              style="transform: translateX(1px);"
              width="14"
              height="27"
              viewBox="0 0 14 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4716 12.3839C13.9403 13.0084 13.9425 13.8667 13.4771 14.4936L4.40219 26.7174C4.28378 26.8769 4.06254 26.9183 3.89439 26.8125C1.12215 25.0684 0.0229001 21.4463 1.34772 18.451C2.16264 16.6085 3.0307 14.9994 4.50944 13.6297C4.62106 13.5263 4.62048 13.3476 4.50817 13.2449C3.02408 11.8885 2.18653 10.363 1.39512 8.59294C0.0571393 5.60036 1.12328 1.9652 3.88016 0.191704C4.04811 0.0836644 4.27099 0.123688 4.39085 0.283411L13.4716 12.3839Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}
